export default __webpack_public_path__ + "static/media/skills.593be15d.png";